import { SensorDetails } from '@/models/sensor-details'

export class Sensor {
  id?: string
  databaseId?: number
  mac?: string
  sensorType?: string
  companyId?: string
  details?: SensorDetails

  constructor(params?: Partial<Sensor>) {
    Object.assign(this, params)
  }
}